<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-md-12">
                <form @submit.prevent="save">
                    <div class="card">
                        <div class="card-header">
                            <i class="fas fa-weight-hanging"></i> Peso
                        </div>
                        <div class="card-block form form-horizontal">
                            <div class="form-group row">
                                <div
                                    class="col-md-2"
                                    :class="{ 'has-danger': $v.model.peso.$error }"
                                >
                                    <label>Peso (Kg)</label>
                                    <masked-input
                                        v-model.trim="model.peso"
                                        mask="##.##"
                                        class="form-control"
                                    />
                                </div>
                                <div
                                    class="col-md-5"
                                    :class="{ 'has-danger': $v.model.data.$error }"
                                >
                                    <label>Data*</label>
                                    <flat-pickr
                                        v-model="model.data"
                                        :config="config"
                                        class="form-control"
                                        placeholder="Selecione"
                                        name="date"
                                    ></flat-pickr>
                                </div>
                            </div>
                        </div>

                        <div class="card-footer text-right">
                            <router-link
                                :to="{name: 'list-weight-pet', params: { id: this.$route.params.id}}"
                                class="btn btn-link"
                            >Cancelar</router-link>
                            <button type="submit" class="btn btn-primary">Salvar</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import Facade from "../../../facade/facade";
const facade = new Facade();
import {
    required,
    minLength,
    maxLength,
    withParams,
    email,
    formatCep
} from "vuelidate/lib/validators";
import {
    isNotUndefinedOrNullOrEmptyOrZero,
    isUndefinedOrNullOrEmpty
} from "@/services/string";
import Collections from "@/helpers/collections";
import Select2 from "../../../components/Input/Select2";
import FileImage from "../../../components/Input/FileImage";
import SelectApi from "../../../components/Input/SelectApi";
import flatPickr from "vue-flatpickr-component";
import { Portuguese } from "flatpickr/dist/l10n/pt.js";

export default {
    components: { Select2, FileImage, SelectApi, flatPickr },
    data() {
        return {
            model: {
                id: null,
                data: "",
                idPet: "",
                peso: ""
            },
            file: null,
            config: {
                wrap: true,
                enableTime: false,
                time_24hr: false,
                locale: Portuguese,
                altInput: true,
                altFormat: "d/m/Y ",
                allowInput: true,
                maxDate: new Date()
            }
        };
    },
    validations() {
        return {
            model: {
                data: {
                    required
                },
                peso: {
                    required,
                    minLength: minLength(4)
                }
            }
        };
    },
    methods: {
        async save() {
            let vm = this;

            if (this.$v.model.$invalid) {
                this.$v.model.$touch();
                this.$notify.warning(
                    "Atenção!",
                    "Verifique se todos os campos estão preenchidos corretamente."
                );
                return;
            }

            this.$loading.show(true);
            vm.model.idPet = this.$route.params.id;

            if (vm.model.id) {
                let ret = facade.updateWeight(vm.model, vm.model.id);
                ret.then(weight => {
                    this.$router.push({
                        name: "list-weight-pet",
                        params: {
                            id: this.$route.params.id,
                            idWeight: this.$route.params.idWeight
                        }
                    });
                    this.$loading.show(false);
                }).catch(e => {
                    e.forEach(item => {
                        this.$notify.error(item.field, item.message);
                    });
                    this.$loading.show(false);
                });
            } else {
                try {
                    let ret = facade.createWeight(vm.model);
                    ret.then(weight => {
                        this.$router.push({
                            name: "list-weight-pet",
                            params: {
                                id: this.$route.params.id,
                                idWeight: this.$route.params.id
                            }
                        });
                        this.$loading.show(false);
                    }).catch(e => {
                        e.forEach(item => {
                            this.$notify.error(item.field, item.message);
                        });
                        this.$loading.show(false);
                    });
                } catch (e) {
                    e.forEach(item => {
                        this.$notify.error(item.field, item.message);
                    });
                    this.$loading.show(false);
                }
            }
        },
        throwError(e) {
            this.$notify.error("Erro!", e);
        },
        setData(weight) {
            let vm = this;
            if (weight !== undefined && weight !== null) {
                this.model = weight;
            }
        }
    },
    async beforeRouteEnter(to, from, next) {
        const vm = this;
        Promise.all([
            to.params.idWeight ? facade.getWeight(to.params.idWeight) : null
        ])
            .then(response => {
                next(vm =>
                    vm.setData(
                        response[0] != null ? response[0].data.data : null
                    )
                );
            })
            .catch(e => {
                next(vm => vm.setData());
            });
    }
};
</script>



// WEBPACK FOOTER //
// Form.vue?d57b9990